import { Typography } from "antd"
import { BaseType } from "antd/es/typography/Base"
import { MouseEventHandler } from "react"

type Props = {
  children: string | React.ReactNode
  type?: BaseType | "link"
  href?: string
  target?: string
  onClick?: MouseEventHandler<HTMLElement>
  onAuxClick?: MouseEventHandler<HTMLElement>
}

type HeaderProps = {
  children: string | React.ReactNode
  level?: 1 | 2 | 3 | 4 | 5
}

export const Text: React.FC<Props> = ({
  type,
  children,
  href,
  target,
  onClick,
  onAuxClick,
}) =>
  type === "link" ? (
    <Typography.Link
      href={href}
      target={target}
      onClick={onClick}
      onAuxClick={onAuxClick}
    >
      {children}
    </Typography.Link>
  ) : (
    <Typography.Text type={type}>{children}</Typography.Text>
  )

export const Header: React.FC<HeaderProps> = ({ children, level }) => (
  <Typography.Title level={level}>{children}</Typography.Title>
)
